import styled from 'styled-components';
import { mixins } from '4all-ui/styles';

export const Container = styled.div`
  ${mixins.flexPosition({ justify: 'space-between' })}
  margin: 20px auto;
  width: ${mixins.getColSize(12)};
`;

export const OrderContainer = styled.div`
  width: ${mixins.getColSize(8)};
`;

export const OrderListContainer = styled.div`
  width: ${mixins.getColSize(4)};
`;



// WEBPACK FOOTER //
// ./src/screens/Home/style.js